import { Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService, SucursalEcommerce, Usuario } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MenuMmaxInterface } from '../../etc/mmax-menu.interface';
import { MarianomGeneral } from '../../marianom-general.service';
import * as L from 'leaflet';

const SUCURSALES_MAPA_DEFAULT_LAT = -34.6037;
const SUCURSALES_MAPA_DEFAULT_LNG = -58.3816;

@Component({
  selector: 'sucursales-mmax',
  templateUrl: './sucursalesmmax.component.html',
  styleUrls: ['./sucursalesmmax.component.scss']
})

export class SucursalesmmaxComponent implements OnInit, OnDestroy {
  @Input() loader: string;

  sucursalesPropias: SucursalEcommerce[];
  sucursalSelecionada: SucursalEcommerce;
  usuario: Usuario;
  nombreSucursal: string;
  sucZero: boolean = false;
  buscandoUbicacion: boolean = false;
  errorUbicacion: boolean = false;
  private autoAbrioModal: boolean = false;
  private autoConfirmoUnica: boolean = false;

  private mapaSucursales: L.Map | null = null;
  private markersSucursales: Map<number, L.Marker> = new Map();
  private mapaSucursalesInicializado: boolean = false;

  constructor(private serv: MarianomGeneral, private genServ: EcommerceGenericoService, private router: ActivatedRoute, private modal: ModalService, private ngZone: NgZone) {
    this.nombreSucursal = "Sin Definir";
    this.loader = this.loader || 'none';
    this.genServ.getSucursalesProviders().subscribe({
      next: sucursales => {
        if (sucursales.length === 0) {
          return
        }
        this.sucursalesPropias = sucursales;
        if (this.unicaSucursal) {
          this.elegirSucursal(sucursales[0].sucursal.toString());
        }
        setTimeout(() => this.actualizarMapaSucursales(), 50);

        setTimeout(() => {
          if (!this.usuario && !this.autoAbrioModal && !this.unicaSucursal) {
            this.autoAbrioModal = true;
            this.modal.open('sucursal-modal-1');
          }
        }, 800);

        this.genServ.getUsuarioProvider().subscribe({
          next: usuarioActual => {
            if (usuarioActual === undefined) {
              return
            }
            this.usuario = usuarioActual;
            let sucursales = this.genServ.getSucursales();
            let sucTrue = false;
            for (let i = 0; i < sucursales.length; i++) {
              const element = sucursales[i];
              if (element.sucursal == this.usuario.sucursal) {
                sucTrue = true;
              }
            }
            if (sucTrue == false && this.unicaSucursal) {
              this.confirmarUnicaSucursal();
            }
            else if (sucTrue == false) {
              this.sucZero = true;
              this.nombreSucursal = (" Sin Definir");
              if (!this.autoAbrioModal) {
                this.autoAbrioModal = true;
                setTimeout(() => {
                  this.modal.open('sucursal-modal-1');
                }, 300);
              }
            }
            else {
              this.nombreSucursal = this.usuario.sucursalNombre || ' Sin Definir';
              if (sucursales) {
                const sucursalDeUsuario: SucursalEcommerce = sucursales.find(
                  (sucursal: SucursalEcommerce) => {
                    return sucursal.sucursal === this.usuario.sucursal
                  }
                )
                if (sucursalDeUsuario) {
                  setTimeout(() => {
                    this.elegirSucursal(sucursalDeUsuario.sucursal.toString());
                  }, 1000);
                }
              }
            }
            setTimeout(() => this.actualizarMapaSucursales(), 50);
          }
        });
      }
    });
  }

  ngOnInit(): void {
    this.fixLeafletIcons();
  }

  ngOnDestroy(): void {
    this.destruirMapaSucursales();
  }

  get menus(): MenuMmaxInterface[] {
    return this.serv.rutas
  }

  get unicaSucursal(): boolean {
    return this.sucursalesPropias?.length === 1;
  }

  get validScuru(): boolean {
    return this.sucursalSelecionada == undefined;
  }

  usarMiUbicacion() {
    this.errorUbicacion = false;
    if (!('geolocation' in navigator)) {
      this.errorUbicacion = true;
      return;
    }
    this.buscandoUbicacion = true;
    navigator.geolocation.getCurrentPosition(
      (posicion) => {
        this.buscandoUbicacion = false;
        const cercana = this.buscarSucursalMasCercana(posicion.coords.latitude, posicion.coords.longitude);
        if (cercana) {
          this.elegirSucursal(cercana.sucursal.toString());
        } else {
          this.errorUbicacion = true;
        }
      },
      () => {
        this.buscandoUbicacion = false;
        this.errorUbicacion = true;
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  }

  private buscarSucursalMasCercana(latitud: number, longitud: number): SucursalEcommerce {
    let masCercana: SucursalEcommerce;
    let distanciaMinima = Infinity;
    (this.sucursalesPropias || []).forEach(sucursal => {
      const sucLat = parseFloat(sucursal.latitud);
      const sucLon = parseFloat(sucursal.longitud);
      if (isNaN(sucLat) || isNaN(sucLon)) {
        return;
      }
      const distancia = this.distanciaEnKm(latitud, longitud, sucLat, sucLon);
      if (distancia < distanciaMinima) {
        distanciaMinima = distancia;
        masCercana = sucursal;
      }
    });
    return masCercana;
  }

  private distanciaEnKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const radioTierraKm = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return radioTierraKm * c;
  }

  elegirSucursal(idSucursal: string) {
    this.sucursalesPropias.forEach(
      sucursalPropia => {
        if (sucursalPropia.sucursal.toString() === idSucursal) {
          this.sucursalSelecionada = sucursalPropia;
          this.centrarMapaEnSucursal(sucursalPropia);
        }
      }
    )
    this.genServ.paginadoSuc();
  }

  private fixLeafletIcons() {
    const iconDefault = L.icon({
      iconUrl: 'assets/leaflet/marker-icon.png',
      iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
      shadowUrl: 'assets/leaflet/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    L.Marker.prototype.options.icon = iconDefault;
  }

  private crearPopupSucursal(suc: SucursalEcommerce): HTMLElement {
    const contenedor = document.createElement('div');
    const nombre = document.createElement('strong');
    nombre.textContent = suc.nombre;
    contenedor.appendChild(nombre);

    const direccion = [[suc.calle, suc.numero].filter(Boolean).join(' '), suc.barrio, suc.localidad]
      .filter(Boolean).join(', ');
    if (direccion) {
      contenedor.appendChild(document.createElement('br'));
      contenedor.appendChild(document.createTextNode(direccion));
    }
    if (suc.telefono) {
      contenedor.appendChild(document.createElement('br'));
      contenedor.appendChild(document.createTextNode(suc.telefono));
    }
    return contenedor;
  }

  private actualizarMapaSucursales(): void {
    const el = document.getElementById('mapa-sucursales');
    if (!el || !this.sucursalesPropias) {
      return;
    }

    if (!this.mapaSucursalesInicializado) {
      this.mapaSucursales = L.map('mapa-sucursales', {
        center: [SUCURSALES_MAPA_DEFAULT_LAT, SUCURSALES_MAPA_DEFAULT_LNG],
        zoom: 12
      });
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 19
      }).addTo(this.mapaSucursales);
      this.mapaSucursalesInicializado = true;
    }

    const mapa = this.mapaSucursales;
    if (!mapa) {
      return;
    }
    mapa.invalidateSize();

    this.markersSucursales.forEach(marker => marker.remove());
    this.markersSucursales.clear();

    const puntos: L.LatLngExpression[] = [];
    this.sucursalesPropias.forEach(suc => {
      const lat = parseFloat(suc.latitud);
      const lng = parseFloat(suc.longitud);
      if (isNaN(lat) || isNaN(lng)) {
        return;
      }
      puntos.push([lat, lng]);
      const marker = L.marker([lat, lng]).addTo(mapa).bindPopup(this.crearPopupSucursal(suc));
      marker.on('click', () => {
        this.ngZone.run(() => this.elegirSucursal(suc.sucursal.toString()));
      });
      this.markersSucursales.set(suc.sucursal, marker);
    });

    if (puntos.length > 0) {
      mapa.fitBounds(L.latLngBounds(puntos), { padding: [30, 30] });
    } else {
      mapa.setView([SUCURSALES_MAPA_DEFAULT_LAT, SUCURSALES_MAPA_DEFAULT_LNG], 12);
    }

    if (this.sucursalSelecionada) {
      this.centrarMapaEnSucursal(this.sucursalSelecionada);
    }
  }

  private centrarMapaEnSucursal(suc: SucursalEcommerce): void {
    if (!this.mapaSucursales) {
      return;
    }
    const lat = parseFloat(suc.latitud);
    const lng = parseFloat(suc.longitud);
    if (isNaN(lat) || isNaN(lng)) {
      return;
    }
    this.mapaSucursales.setView([lat, lng], 15);
    const marker = this.markersSucursales.get(suc.sucursal);
    if (marker) {
      marker.openPopup();
    }
  }

  private destruirMapaSucursales(): void {
    if (this.mapaSucursales) {
      this.mapaSucursales.remove();
      this.mapaSucursales = null;
      this.mapaSucursalesInicializado = false;
      this.markersSucursales.clear();
    }
  }

  private async confirmarUnicaSucursal() {
    if (this.autoConfirmoUnica) {
      return;
    }
    this.autoConfirmoUnica = true;
    const unica = this.sucursalesPropias[0];
    try {
      await this.genServ.cambiarSucursalV2(unica.sucursal.toString());
      this.sucZero = false;
      this.nombreSucursal = ' ' + unica.nombre;
    } catch (err) {
      this.autoConfirmoUnica = false;
      console.error('No se pudo asignar la sucursal unica:', err);
    }
  }

  async cambiarSucursal() {
    if (localStorage.getItem('currentUser') != null || localStorage.getItem('currentUser') != undefined || this.serv.isloged() == true) {
      if (this.sucursalSelecionada === undefined) {
        this.modal.open('modal-seleccione-suc');
      }
      else {
        this.loader = 'block';
        for (let i = 0; i < this.menus.length; i++) {
          const element = this.menus[i];
          element.activo = false;
        }

        try {
          await this.genServ.cambiarSucursalV2(this.sucursalSelecionada.sucursal.toString());
          this.serv.setMenuActivoNombre('landing')
          this.serv.navigator.goLandPage(this.router);
          this.modal.close('sucursal-modal-1');
        } catch (err) {
          console.error('DEBUG: sucursal change failed:', err);
        } finally {
          this.loader = 'none';
        }

      }
    } else {
      this.serv.abrirModalLogin();
    }
  }

}
